import styles from "./Publications.module.css";
import { publications } from "../../store/store";
import Publication from "../../components/Publication";
import SEO from "../../seo/SEO";

export default function Publications() {
  return (
    <div className={`container`}>
      <SEO
        title={"Δημοσιεύσεις και Ακαδημαϊκή Δράση"}
        description={
          "Η ακαδημαϊκή συνεισφορά και οι ερευνητικές δημοσιεύσεις του δικηγόρου Χαλντούν Σόρτογλου."
        }
      />
      <h2 className={styles[`publication-title`]}>
        Δημοσιεύσεις και Ακαδημαϊκή Δράση
      </h2>
      <div className={styles.publications}>
        {publications.map((pub) => (
          <Publication pubContent={pub} />
        ))}
      </div>
    </div>
  );
}
